import React from "react";
import { Mutator, MutableState, Tools } from "final-form";
import { FormSpy } from "react-final-form";
import set from "lodash/set";
import debounce from "lodash/debounce";
import debug from "../../utils/debug";
import { POJO } from "../../types";

interface MutatorsWithUpdateFormState {
  [key: string]: (...args: any[]) => any;
}

let updateTheFormStateWithData: POJO = {};

document.addEventListener("form.updateState", event => {
  debug("[ConfigurableForm] form.updateState", { event });
  updateTheFormStateWithData = (event as CustomEvent).detail;
});

// Update form state
export const updateFormState: Mutator = (
  args: any[],
  state: MutableState<any>,
  tools: Tools<any>
) => {
  debug("[ConfigurableForm] updateFormState", {
    args,
    state,
    tools,
    updateTheFormStateWithData
  });

  if (updateTheFormStateWithData) {
    Object.keys(updateTheFormStateWithData).forEach(fieldName => {
      set(
        state.formState.values,
        fieldName,
        updateTheFormStateWithData[fieldName]
      );
    });
  }

  // Reset the update data since we only want to use the data once
  updateTheFormStateWithData = {};
};

// Only update if there's data to update with
const handleFormSpyOnChange = (updateFormState: Function) =>
  debounce(() => {
    if (
      updateTheFormStateWithData &&
      Object.keys(updateTheFormStateWithData).length
    ) {
      updateFormState("address", updateTheFormStateWithData);
    }
  }, 50);

export default function UpdateFormState({
  mutators: { updateFormState }
}: {
  mutators: MutatorsWithUpdateFormState;
}) {
  return (
    <FormSpy
      subscription={{ values: true }}
      onChange={handleFormSpyOnChange(updateFormState)}
    />
  );
}
